import React from 'react';
import { ServicesSolutions } from '../components/ServicesSolutions';
export function ServicesPage() {
  return <main data-id="element-230">
      <ServicesSolutions data-id="element-231" />
    </main>;
}